import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { AppProvider, useApp } from './context/AppContext';
import { CatalogProvider } from './context/CatalogContext';
import { ThemeProvider } from './context/ThemeContext';
import { Layout } from './components/Layout';

import { Login } from './pages/Login';
import { Otp } from './pages/Otp';
import { Home } from './pages/Home';
import { Store } from './pages/Store';
import { Category } from './pages/Category';
import { ProductDetail } from './pages/ProductDetail';
import { Cart } from './pages/Cart';
import { Library } from './pages/Library';
import { Profile } from './pages/Profile';
import { PracticeSetup } from './pages/PracticeSetup';
import { PracticeSession } from './pages/PracticeSession';
import { Bookmarks } from './pages/Bookmarks';

function Loading() {
  return (
    <div className="loading-screen">
      <div className="spinner" />
    </div>
  );
}

function RequireAuth() {
  const { ready, isLoggedIn } = useApp();
  if (!ready) return <Loading />;
  if (!isLoggedIn) return <Navigate to="/login" replace />;
  return <Outlet />;
}

export function App() {
  return (
    <ThemeProvider>
      <CatalogProvider>
        <AppProvider>
          <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/otp" element={<Otp />} />
            <Route element={<RequireAuth />}>
              <Route element={<Layout />}>
                <Route index element={<Home />} />
                <Route path="store" element={<Store />} />
                <Route path="library" element={<Library />} />
                <Route path="profile" element={<Profile />} />
                <Route path="category/:type" element={<Category />} />
                <Route path="product/:id" element={<ProductDetail />} />
                <Route path="cart" element={<Cart />} />
                <Route path="bookmarks" element={<Bookmarks />} />
                <Route path="practice/:productId" element={<PracticeSetup />} />
                <Route path="practice/session/:id" element={<PracticeSession />} />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AppProvider>
      </CatalogProvider>
    </ThemeProvider>
  );
}
